export default __webpack_public_path__ + "static/cbgoildwholsale-79c06070ba44313175b3266088a16cbe.png";